export default "__VITE_ASSET__a5231937__"